import React from "react";
import PropTypes from "prop-types";
import { refPropType } from "../utils";

function getLetter(index) {
  return String.fromCharCode(65 + index);
}

function getChoiceClassName(isSelected) {
  const baseClassName = "th-agentforce-assessment__mcq-choice";
  return isSelected ? `${baseClassName} ${baseClassName}--selected` : baseClassName;
}

const MCQChoices = ({ choices, questionId, questionPrompt = "", selectedId = null, onChange, disabled = false, firstChoiceRef = null }) => (
  <fieldset className="th-agentforce-assessment__mcq-choices">
    <legend className="th-sr-only">{questionPrompt}</legend>
    {choices.map((choice, index) => {
      const isSelected = selectedId === choice.id;
      const choiceClassName = getChoiceClassName(isSelected);

      return (
        <label
          key={choice.id}
          className={choiceClassName}>
          <input
            ref={index === 0 ? firstChoiceRef : null}
            type="radio"
            className="th-agentforce-assessment__mcq-choice-input"
            name={`assessment-framework-question-${questionId}`}
            value={choice.id}
            checked={isSelected}
            disabled={disabled}
            onChange={() => onChange(choice.id)}
          />
          <span className="th-agentforce-assessment__mcq-choice-letter" aria-hidden="true">
            {getLetter(index)}
          </span>
          <span className="th-agentforce-assessment__mcq-choice-body">
            <span className="th-agentforce-assessment__mcq-choice-text">{choice.text}</span>
            {choice.supportive_text && (
              <span className="th-agentforce-assessment__mcq-choice-supportive">
                {choice.supportive_text}
              </span>
            )}
          </span>
        </label>
      );
    })}
  </fieldset>
);

MCQChoices.propTypes = {
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      supportive_text: PropTypes.string,
    })
  ).isRequired,
  questionId: PropTypes.string.isRequired,
  questionPrompt: PropTypes.string,
  selectedId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  firstChoiceRef: refPropType,
};

export default MCQChoices;
